// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Honors_honors__mZiNB .Honors_honor-wrapper__zBBSe {
  background: white;
  padding: 15px 20px;
  border-radius: 5px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.Honors_honors__mZiNB .Honors_honor-wrapper__zBBSe .Honors_delete-honor__v1GyI {
  margin-top: 5px;
}
.Honors_honors__mZiNB .Honors_honor-wrapper__zBBSe .Honors_delete-honor__v1GyI svg {
  cursor: pointer;
}
.Honors_honors__mZiNB .Honors_honor-wrapper__zBBSe .Honors_delete-honor__v1GyI svg path {
  stroke: red;
}
.Honors_honors__mZiNB .Honors_section-title__qKQYh {
  color: var(--dark-grey);
  font-weight: bold;
}
.Honors_honors__mZiNB .Honors_add-button__5SpTc {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/PersonalProfile/Components/Honors/Honors.module.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AAAJ;AACI;EACE,eAAA;AACN;AAAM;EACE,eAAA;AAER;AADQ;EACE,WAAA;AAGV;AAEE;EACE,uBAAA;EACA,iBAAA;AAAJ;AAEE;EACE,mBAAA;AAAJ","sourcesContent":[".honors {\n  .honor-wrapper {\n    background: white;\n    padding: 15px 20px;\n    border-radius: 5px;\n    margin-bottom: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    .delete-honor {\n      margin-top: 5px;\n      svg {\n        cursor: pointer;\n        path {\n          stroke: red;\n        }\n      }\n    }\n  }\n  .section-title {\n    color: var(--dark-grey);\n    font-weight: bold;\n  }\n  .add-button {\n    margin-bottom: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"honors": `Honors_honors__mZiNB`,
	"honor-wrapper": `Honors_honor-wrapper__zBBSe`,
	"delete-honor": `Honors_delete-honor__v1GyI`,
	"section-title": `Honors_section-title__qKQYh`,
	"add-button": `Honors_add-button__5SpTc`
};
export default ___CSS_LOADER_EXPORT___;
